<template>
    <input :class="_class" v-bind="$attrs" v-bind:value="value"  v-on="inputListeners"/>
</template>

<script>
export default {
    props: {
        is_last: {
            type: Boolean
        },
        size: {
            type: String
        },
        value: {
            default: null
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    computed: {
        _class() {
            let _class = []

            _class.push('form-control')

            if(this.is_last === true) {
                _class.push('form-control-last')
            }

            if(this.size) {
                _class.push('form-control-'+this.size)
            }

            return _class
        },
        inputListeners() {
            var vm = this
            // `Object.assign` merges objects together to form a new object
            return Object.assign({},
                // We add all the listeners from the parent
                this.$listeners,
                // Then we can add custom listeners or override the
                // behavior of some listeners.
                {
                // This ensures that the component works with v-model
                input: function (event) {
                    vm.$emit('input', event.target.value)
                    }
                }
            )
        }
    },
}
</script>